import React from "react";
import KuikaInfoBox, { KuikaInfoBoxColor } from "../../../../ui-kit/kuika-info-box/kuika-info-box";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";
import { VariantGrid } from "../_layout/variant-grid";

const COLORS: KuikaInfoBoxColor[] = ["white", "gray", "blue", "yellow", "red", "green"];

export const InfoBoxStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Info Box"
      componentName="KuikaInfoBox"
      sourcePath="ui-kit/kuika-info-box"
      description="Static info banner. Two ReactNode slots (left/right) with two neutral boxes and four tone callouts."
    >
      <VariantGrid
        label="color"
        cols={COLORS}
        cellMinWidth={220}
        render={(color: string): React.ReactNode => (
          <KuikaInfoBox
            color={color as KuikaInfoBoxColor}
            leftUnit={
              <span style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
                <KuikaSvg name="info-circle" width={14} height={14} />
                {color}
              </span>
            }
            rightUnit={
              <span style={{ fontFamily: "var(--lab-mono)", fontSize: 11 }}>
                {color === "red" ? "blocking" : "note"}
              </span>
            }
          />
        )}
      />
      <SpecRow label="Without right unit" align="stretch">
        <div style={{ width: 380 }}>
          <KuikaInfoBox color="blue" leftUnit="Your changes are saved to the cloud automatically." />
        </div>
      </SpecRow>
      <SpecRow label="Stacked tones" align="stretch">
        <div className="lab-stack" style={{ width: 420 }}>
          {COLORS.map((c: KuikaInfoBoxColor) => (
            <KuikaInfoBox key={c} color={c} leftUnit={`Tone · ${c}`} rightUnit="meta" />
          ))}
        </div>
      </SpecRow>
    </ShowcaseFrame>
  );
};
